<template lang="html">
    <div class="container-fluid p-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                   <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="mb-0">Receive List</h5>
                        <div class="d-flex align-items-center">
                            <router-link to="receipt-create" class="btn btn-primary">
                                <i class="fas fa-plus"></i> New Receive
                            </router-link>
                        </div>
                    </div>
                    <div class="card-body">
                         <div class="row search-form">
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_receipt" class="form-control" placeholder="Search by Receipt Number">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_batch" class="form-control" placeholder="Search by Batch Code, Batch Name">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_fee" class="form-control" placeholder="Search by Fee Code, Fee Name">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_student" class="form-control" placeholder="Search by Student Code, Student Name">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input onfocus="(this.type='date')" v-model="filter.date_from" class="form-control" placeholder="From Date">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input onfocus="(this.type='date')" v-model="filter.date_to" class="form-control" placeholder="To Date">
                            </div>
                            <div class="col-md-3 mt-1">
                                <button class="btn btn-primary mr-1 fbutton" @click="search()"><i class="fas fa-search"></i> Search</button>
                                <button class="btn btn-info fbutton" @click="reset()"><i class="fas fa-sync"></i> Refresh</button>
                            </div>
                        </div>
                        <div class="table-responsive mt-4">
                            <table class="common-table">
                                <thead>
                                    <tr>
                                        <th v-for="(value, key) in visibleColumns" :key="key" @click="sortBy(key)" style="cursor:pointer">
                                            {{ value }}
                                            <span v-if="filter.sort_by === key">
                                                <i v-if="filter.orderBy === 'asc'" class="fas fa-sort-up"></i>
                                                <i v-else class="fas fa-sort-down"></i>
                                            </span>
                                        </th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, index) in dataList" :key="data.id">
                                        <td>{{ data.receipt_number }}</td>
                                        <td>{{ data.enrollment.batch.code1 }}{{ data.enrollment.batch.code2 }}{{ data.enrollment.batch.code3 }}</td>
                                        <td>{{ data.enrollment.fee.code }}</td>
                                        <td>{{ data.enrollment.student.student_code }}</td>
                                        <td>{{ data.enrollment.student.name }}</td>
                                        <td>{{ data.date_issued }}</td>
                                        <td v-if="user.type == 'a1'">{{ data.enrollment.original_amount }}</td>
                                        <td>{{ data.enrollment.discount_amount }}</td>
                                        <td>{{ data.enrollment.amount }}</td>
                                        <td v-if="user.type == 'a1'">{{ data.enrollment.remain_amount }}</td>
                                        <td>{{ data.amount }}</td>
                                        <td>
                                            <a  class="btn btn-option text-success" v-b-modal.bv-modal-editfee @click="printDataModal(data)"><i class="fas fa-print"></i></a>
                                            <!-- <button class="btn btn-option text-primary" @click="editData(data)"><i class="fas fa-eye"></i></button> -->
                                            <!-- <button v-b-modal.bv-modal-delete class="btn btn-option text-danger" @click="deleteData(data)"><i class="fas fa-trash-alt"></i></button> -->
                                        </td>
                                    </tr>
                                    <tr v-if="dataList.length > 0" class="table-summary font-weight-bold text-white" style="background-color: #4e8889;">
                                        <td class="text-center" colspan="6">
                                           TOTAL
                                        </td>
                                        <td v-if="user.type == 'a1'">{{ totalData.original_enrollment_amount }}</td>
                                        <td>{{ totalData.discount_enrollment_amount }}</td>
                                        <td>{{ totalData.total_enrollment_amount }}</td>
                                        <td v-if="user.type == 'a1'">{{ totalData.remain_enrollment_amount }}</td>
                                        <td>{{ totalData.received_amount }}</td>
                                        <td></td>
                                    </tr>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="Object.keys(columns).length + 1" class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-pagination-minimal">
                            <div class="table-pagination-row">
                                <div v-if="dataList.length > 0 " class="table-info-minimal left-align">
                                    Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                                </div>
                                <nav class="pagination-minimal">
                                    <ul>
                                        <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                            <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                                <i class="fas fa-angle-left"></i>
                                            </button>
                                        </li>
                                        <li v-for="page in metaData.last_page" :key="page"
                                            :class="{ 'active':metaData.current_page === page }"
                                            v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                            <button @click.prevent="next(page)">{{ page }}</button>
                                        </li>
                                        <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                            <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                                <i class="fas fa-angle-right"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <b-modal id="bv-modal-editfee" ref="my-modal" title="Print Receipt" hide-footer size="md">
                            <template>
                                <div class="form-group">
                                    <label for="inputCode">Print Date</label>
                                    <input type="date" v-model="printDate" id="inputCode" class="form-control">
                                </div>
                                <b-button class="mt-3 btn-success" block @click="printReceipt()">Submit</b-button>
                            </template>
                        </b-modal>
                        <div id="printMe" class="print-hidden">
                            <div class="receipt-container">

                                <div class="header">
                                    <div class="header-logo">
                                        <img src="@/assets/img/print.jpg" alt="Logo" />
                                    </div>
                                    <h3>Myanmar Imperial College</h3>
                                    <p>No.1, Zay Mysuk St., Phayagyi Ward, Dagon Tsp., Yangon, Myanmar.</p>
                                    <p>Tel:(95-9) 73210001, 5042473</p>
                                </div>

                                <div class="info-top">
                                    <div>
                                        <label>Date :</label>
                                        <span class="date-srno-data">{{ printDate || 'N/A' }}</span>
                                    </div>
                                    <div>
                                        <label>Sr.No :</label>
                                        <span class="date-srno-data">{{ printData.receipt_number || 'N/A' }}</span>
                                    </div>
                                </div>

                                <div class="title">
                                    OFFICIAL RECEIPT
                                </div>

                                <table class="main-table">
                                    <tr class="student-info-row">
                                        <td class="info-label label-color">Student Name (As in passport)</td>
                                        <td class="data-value" colspan="2">{{ printData.enrollment ? printData.enrollment.student.name : 'N/A' }}</td>
                                    </tr>
                                    <tr class="student-info-row">
                                        <td class="info-label">Student Identification No:</td>
                                        <td>{{ printData.enrollment ? printData.enrollment.student.student_code : 'N/A' }}</td>
                                        <td class="info-label">Student Registration No:</td>
                                    </tr>
                                    <tr class="student-info-row">
                                        <td class="info-label" rowspan="2">This fees are paid for</td>
                                        <td class="info-label" colspan="2">Courses</td>
                                    </tr>
                                    <tr class="student-info-row">
                                        <td colspan="2"> Specification</td>
                                    </tr>
                                </table>

                                <table class="main-table description-section">
                                    <thead>
                                        <tr>
                                            <th style="width: 25%;" colspan="2">DESCRIPTION</th>
                                            <th style="width: 25%;" colspan="2">TOTAL AMOUNT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td class="description-cell" colspan="2">
                                            <div class="handwriting-description">
                                                {{ printData.enrollment ? `${printData.enrollment.batch.code1}${printData.enrollment.batch.code2}${printData.enrollment.batch.code3} - ${printData.enrollment.fee.code}` : 'N/A' }}<br>
                                                <span v-for="payment_term in printData.terms" :key="payment_term.id">{{ payment_term.payment_sequence }}
                                                <span v-if="!isLast(payment_term)"> & </span>
                                                </span>
                                                <br>
                                                Receipt Date: {{ printData.date_issued || 'N/A' }}
                                                <br>
                                                <span v-for="(payment, index) in printData.receipt_payments" :key="payment.id">
                                                   <span v-if="index > 0">,</span> {{ payment.bank_info.bank_name }}
                                                </span>
                                            </div>
                                        </td>
                                        <td colspan="2" class="amount-cell" style="border-left: none; vertical-align: middle;">
                                            <span class="total-amount-handwritten">{{ printData.amount ? `${printData.amount}/-` : 'N/A' }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" rowspan="3" class="signature-cell">
                                            <div class="signature-section">
                                            <div>
                                                Student's Signature: ----------------
                                
                                            </div>
                                            <div style="position: relative;">
                                                    Receiver's Signature: ----------------
                                            </div>
                                            </div>
                                        </td>
                                        <td>NET</td>
                                        <td class="amount-cell"><span class="total-amount-handwritten">{{ printData.amount ? `${printData.amount}/-` : 'N/A' }}</span></td>
                                    </tr>
                                    <tr>
                                        <td>TAX</td>
                                        <td class="amount-cell"><span class="total-amount-handwritten">-</span></td>
                                    </tr>
                                    <tr>
                                        <td>TOTAL</td>
                                        <td class="amount-cell"><span class="total-amount-handwritten">{{ printData.amount ? `${printData.amount}/-` : 'N/A' }}</span></td>
                                    </tr>
                                    </tbody>
                                </table>

                                <div class="footer-note">
                                    All Fees already paid are Non-Refundable and Non-Transferable.
                                </div>

                            </div>
                        </div>
                        <b-modal id="bv-modal-delete" ref="my-modal" title="Delete" hide-footer>
                            <p class="my-4">Are you sure to delete ? </p>
                            <p class="my-4 text-danger">{{alert}}</p>
                            <b-button class="mt-3 btn-danger" block @click="deleteItem()">Delete</b-button>
                        </b-modal>
                        <!-- <router-link class="float" to="receipt-create">
                            <i class="fa fa-plus my-float" style="padding: 37%;"></i>
                        </router-link> -->
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
import { print } from 'vue-print-nb';
    export default {
        name: 'receiptList',
        metaInfo: {
            title: "Receipt List",
            titleTemplate: "%s ← MIC",
        },
        components: {
            Loading
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                user: null,
                alert: "",
                id: '',
                printDate: '',
                printData: {},
                totalData: [],
                dataList: [],
                commissionData: [],
                permissions: '',
                columns: {
                    receipt_number: 'Receipt Number',
                    batch_code: 'Batch Code',
                    fee_code: 'Fee Code',
                    student_code: 'Student Code',
                    student_name: 'Student Name',
                    date_issued: 'Receipt Date',
                    original_amount: 'Original Fee',
                    discount_amount: 'Discount Amount',
                    total_amount: 'Total Fee',
                    remain_amount: 'Remain Amount',
                    amount: 'Received Amount',
                },
                filter: {
                    page: 1,
                    per_page: 20,
                    sort_direction: "asc",
                    sort_by: "created_at",
                    limit: 20,
                    search_receipt: '',
                    search_batch: '',
                    search_fee: '',
                    search_student: '',
                    date_from: '',
                    date_to: ''
                },
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                }
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
         computed: {
            visibleColumns() {
                // return columns but omit original_amount unless user.type == 'a1'
                const cols = Object.assign({}, this.columns);
                if (!(this.user && this.user.type == 'a1')) {
                    delete cols.original_amount;
                    delete cols.remain_amount;
                }
                return cols;
            },
            visibleColumnsCount() {
                return Object.keys(this.visibleColumns).length;
            }
        },
        methods: {
            ...mapActions({
                getReceiptListAction: 'getReceiptListAction',
                bankDeleteAction: 'bankDeleteAction',
                receiptTotalAction: 'receiptTotalAction'
            }),
            sortBy(column) {
                this.filter.sort_by = column
                if (this.filter.sort_by == column) {
                    if (this.filter.sort_direction == "asc") {
                        this.filter.sort_direction = "desc"
                    } else if (this.filter.sort_direction == "desc") {
                        this.filter.sort_direction = "asc"
                    }
                } else {
                    this.filter.sort_direction = "asc"
                }
                this.fetchData()
            },
            async search() {
                this.filter.page = 1
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async fetchData() {
                this.isLoading = true
                // Update the page query parameter in the URL
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.filter.page
                    }
                });
                let option = this.filter
                await this.getReceiptListAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data.data
                        this.metaData.last_page = res.data.meta.last_page
                        this.metaData.current_page = res.data.meta.current_page
                        this.metaData.prev_page_url = res.data.meta.prev_page_url
                        this.metaData.from = res.data.meta.from
                        this.metaData.to = res.data.meta.to
                        this.metaData.total = res.data.meta.total
                        this.isLoading = false;

                        this.fetchTotalData()
                    }
                }).catch(err => this.isLoading = true)
            },
            async fetchTotalData() {
                this.isLoading = true
                // Update the page query parameter in the URL
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.filter.page
                    }
                });
                let option = this.filter
                await this.receiptTotalAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.totalData = res.data
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            reset(){
                this.$router.replace({ 
                    path: 'receipt-list', 
                    query: {
                        page: 1, 
                        per_page: 10,
                        sort_direction: 'desc', 
                        sort_by: 'created_at',
                        search_receipt: '',
                        search_batch: '',
                        search_fee: '',
                        search_student: '',
                        date_from: '',
                        date_to: ''
                    } 
                }).catch(()=>{})
                this.$router.go()
            },
            editData(data) {
                this.$router.replace({ 
                    path: 'enrollment-edit', 
                    query: { 
                        page: this.filter.page,
                        per_page: this.filter.per_page,
                        sort_direction: this.filter.sort_direction, 
                        sort_by: this.filter.sort_by, 
                        id: data.id,
                        search_receipt: this.filter.search_receipt,
                        search_batch: this.filter.search_batch,
                        search_fee: this.filter.search_fee,
                        search_student: this.filter.search_student,
                        date_from: this.filter.date_from,
                        date_to: this.filter.date_to
                    } 
                }).catch(()=>{})
            },
            deleteData(data){
                this.id = data.id
                this.alert = ""
            },
            async deleteItem() {
				this.isLoading = true
				let option = {
					id: this.id,
				}
				await this.bankDeleteAction({
					...option
				}).then(res => {
					if(res.status == 'fail'){
                        this.alert = res.message
                    }else{
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            },
            printDataModal(data) {
                this.printData = data;
            },
            printReceipt() {
                // Use Vue.nextTick to ensure DOM is updated with printData before printing
                this.$nextTick(() => {
                    // Try using vue-html-to-paper first, fallback to custom print
                    if (this.$htmlToPaper) {
                        this.$htmlToPaper('printMe');
                    } else {
                        // Fallback custom print method
                        this.customPrintReceipt();
                    }
                });
            },
            customPrintReceipt() {
                const printContent = document.getElementById('printMe');
                console.log('Print Content Element:', printContent);
                if (!printContent) return;

                // If the print template is hidden via .print-hidden (display:none !important),
                // temporarily remove that class so innerHTML contains the rendered values.
                const hadHidden = printContent.classList.contains('print-hidden');
                if (hadHidden) {
                    printContent.classList.remove('print-hidden');
                }

                // Force a reflow so the browser applies the class change and Vue-rendered text is present
                // before we read innerHTML. This helps avoid timing issues where values appear as
                // mustache placeholders or are not yet reflected in the DOM.
                // Accessing offsetHeight forces reflow.
                void printContent.offsetHeight;

                // Useful debug logs to inspect what we're about to capture
                console.log('printData at print time:', this.printData);
                console.log('Captured print template innerHTML length:', printContent.innerHTML.length);

                const printWindow = window.open('', '_blank', 'width=900,height=650,scrollbars=yes');

                // Build minimal HTML for the print window and inject the captured HTML.
                printWindow.document.write(`
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <title>Receipt Print</title>
                        <link href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" rel="stylesheet">
                        <style>
                            body { margin: 0; padding: 20px; font-family: Arial, sans-serif; }
                            .receipt-container { width: 100%; max-width: 800px; margin: 0 auto; padding: 20px; border: 2px solid #000; background-color: #fff; }
                            .header { text-align: center; margin-bottom: 15px; position: relative; }
                            .header-logo { width: 150px; height: auto; margin-bottom: 10px; display: block; margin-left: auto; margin-right: auto; }
                            .header-logo img { width: 100%; height: auto; max-height: 80px; object-fit: contain; }
                            .header h3 { margin: 0; font-size: 14pt; font-weight: bold; }
                            .header p { margin: 2px 0; font-size: 9pt; }
                            .title { text-align: center; font-size: 16pt; font-weight: bold; margin: 20px 0; padding: 5px 0; letter-spacing: 2px; }
                            .info-top { display: block; width: 300px; margin: 0 0 10px auto; font-size: 10pt; text-align: right; }
                            .info-top div { margin-bottom: 5px; line-height: 1.5; }
                            .info-top label { font-weight: bold; display: inline-block; width: 50px; text-align: left; }
                            .info-top span { border-bottom: 1px solid #000; padding: 0 5px; min-width: 150px; display: inline-block; text-align: left; }
                            .main-table { width: 100%; border-collapse: collapse; font-size: 10pt; }
                            .main-table, .main-table th, .main-table td { border: 1px solid #000; }
                            .main-table td.signature-cell { border-left: 1px solid white !important; border-bottom: 1px solid white !important; }
                            .main-table th, .main-table td { padding: 6px 5px; vertical-align: top; }
                            .student-info-row td:first-child { width: 30%; font-weight: bold; padding: 3px 5px; }
                            .student-info-row td:nth-child(2) { width: 35%; font-weight: bold; padding: 3px 5px; }
                            .student-info-row td:nth-child(3) { width: 35%; font-weight: bold; padding: 3px 5px; }
                            .info-label { font-weight: bold; color: #000; }
                            .data-value { font-weight: bold; font-family: 'Arial', sans-serif; font-size: 11pt; color: #333; }
                            .description-section th { text-align: center; }
                            .description-cell { height: 120px; position: relative; padding: 10px; }
                            .amount-cell { text-align: right; white-space: nowrap; }
                            .handwriting-description { font-size: 12pt; font-weight: bold; position: absolute; top: 10px; left: 10px; color: #2c3e50; line-height: 1.5; }
                            .signature-section { display: flex; justify-content: space-evenly; font-size: 10pt; padding-top: 80px; }
                            .signature-cell { border-left: none !important; border-bottom: none !important; }
                            .footer-note { text-align: center; margin-top: 20px; font-size: 9pt; height: 20px; font-weight: bold; background-color: blue; padding-top: 3px; padding-left: 5px; text-align: left; color: white; }
                            .date-srno-data { font-weight: bold; color: #333; }
                            .total-amount-handwritten { font-size: 12pt; color: #2c3e50; }
                            .label-color { background-color: blue; color: white; }
                            @media print {
                                body { margin: 0; padding: 10px; }
                                .receipt-container { border: 2px solid #000; box-shadow: none; margin: 0; padding: 15px; }
                                .label-color { background-color: blue !important; color: white !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                                .footer-note { background-color: blue !important; color: white !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                            }
                        </style>
                    </head>
                    <body>
                        ${printContent.innerHTML}
                    </body>
                    </html>
                `);

                printWindow.document.close();

                // Restore hidden state immediately after capturing DOM
                if (hadHidden) {
                    printContent.classList.add('print-hidden');
                }

                // Debug: open print window and trigger print after a short delay
                setTimeout(() => {
                    printWindow.print();
                    setTimeout(() => {
                        printWindow.close();
                    }, 100);
                }, 250);
            },
            isLast(item) {
                if (!this.printData.terms || !Array.isArray(this.printData.terms)) {
                    return true;
                }
                const index = this.printData.terms.indexOf(item);
                return index === this.printData.terms.length - 1;
            },
            

        },
        mounted() {
           const userStr = window.localStorage.getItem('user');
            console.log(userStr)
            if (userStr) {
                try {
                    this.user = JSON.parse(userStr);
                } catch (e) {
                    this.user = null;
                }
            }

            this.permissions = this.user && this.user.permissions ? this.user.permissions : ''
            this.filter.page = this.$route.query.page
            this.filter.per_page = this.$route.query.per_page
            this.filter.sort_by = this.$route.query.sort_by
            this.filter.sort_direction = this.$route.query.sort_direction
            this.filter.search_receipt = this.$route.query.search_receipt || ''
            this.filter.search_batch = this.$route.query.search_batch || ''
            this.filter.search_fee = this.$route.query.search_fee || ''
            this.filter.search_student = this.$route.query.search_student || ''
            this.filter.date_from = this.$route.query.date_from || ''
            this.filter.date_to = this.$route.query.date_to || ''
            this.fetchData()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
   .badge-16 {
    font-size: 16px;
   }
        .receipt-container {
            width: 1000px;
            height: max-content;
            margin: 0 auto;
            padding: 20px;
            border: 1px solid #000;
            background-color: #fff;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }

        /* Header Styling */
        .header {
            text-align: center;
            margin-bottom: 15px;
            position: relative;
        }

        .header-logo {
            width: 150px;
            height: auto;
            margin-bottom: 10px;
            display: block;
            margin-left: auto;
            margin-right: auto;
        }

        .header-logo img {
            width: 100%;
            height: auto;
            max-height: 80px;
            object-fit: contain;
        }

        @media print {
            .header-logo {
                width: 200px;
                margin-bottom: 8px;
            }
            
            .header-logo img {
                max-height: 150px;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
        }

        .header h3 {
            margin: 0;
            font-size: 14pt;
            font-weight: bold;
        }

        .header p {
            margin: 2px 0;
            font-size: 9pt;
        }

        .title {
            text-align: center;
            font-size: 16pt;
            font-weight: bold;
            margin: 20px 0;
            padding: 5px 0;
            letter-spacing: 2px;
        }

        /* Date and Sr.No Section */
/* Date and Sr.No Section - MODIFIED FOR STACKED LOOK */
        .info-top {
            display: block; /* Change to block to allow stacking */
            width: 300px; /* Give it a fixed width */
            margin: 0 0 10px auto; /* Push the block to the right */
            font-size: 10pt;
            text-align: right;
        }

        .info-top div {
            margin-bottom: 5px; /* Add space between Date and Sr.No */
            line-height: 1.5;
        }

        .info-top label {
            font-weight: bold;
            display: inline-block;
            width: 50px; /* Adjust label width for alignment */
            text-align: left;
        }

        .info-top span {
            border-bottom: 1px solid #000;
            padding: 0 5px;
            min-width: 150px; /* Give more space for the handwritten data */
            display: inline-block;
            text-align: left; /* Keep data left-aligned under the border */
        }

        /* Main Content Table Styling */
        .main-table {
            width: 100%;
            border-collapse: collapse;
            font-size: 10pt;
        }

        .main-table, .main-table th, .main-table td {
            border: 1px solid #000;
        }

        .main-table td.signature-cell {
            border-left: 1px solid white !important;
            border-bottom: 1px solid white !important;
        }

        .main-table th, .main-table td {
            padding: 6px 5px;
            vertical-align: top;
        }

        .main-table .header-row {
            background-color: #ddd; /* Faded background for section headers */
            font-weight: bold;
        }

        /* Specific Table Cell Widths and Styling */
        .student-info-row td:first-child {
            width: 30%; /* Label column */
            font-weight: bold;
            padding: 3px 5px;
        }

        .student-info-row td:nth-child(2) {
            width: 35%; /* Value column 1 */
            font-weight: bold;
            padding: 3px 5px;
        }

        .student-info-row td:nth-child(3) {
            width: 35%; /* Value column 2 */
            font-weight: bold;
            padding: 3px 5px;
        }

        .info-label {
            font-weight: bold;
            color: #000;
        }

        .data-value {
            font-weight: bold;
            /* Mimics handwriting style */
            font-family: 'Handwriting Font', 'Arial', sans-serif; 
            font-size: 11pt;
            color: #333;
        }

        .description-section th {
            text-align: center;
        }

        .description-cell {
            height: 120px; /* Space for description and handwritten notes */
            position: relative;
            padding: 10px;
        }

        .amount-cell {
            text-align: right;
            white-space: nowrap;
        }

        /* Handwritten Content inside Description */
        .handwriting-description {
            font-size: 12pt;
            font-weight: bold;
            position: absolute;
            top: 10px;
            left: 10px;
            color: #2c3e50; /* Darker color for visibility */
            font-family: 'Handwriting Font', 'Arial', sans-serif;
            line-height: 1.5;
        }

        /* Total Section Table */
        .total-table {
            width: 100%;
            margin-top: -1px; /* Overlap with main table border */
        }

        .total-table td {
            border: 1px solid #000;
            padding: 5px;
            font-size: 10pt;
        }

        .total-table td:first-child {
            width: 50%; /* Description column */
        }

        .total-table td:nth-child(2) {
            width: 25%; /* Label (NET/TAX/TOTAL) column */
            font-weight: bold;
        }

        .total-table td:nth-child(3) {
            width: 25%; /* Amount column */
            text-align: right;
            font-weight: bold;
        }

        /* Footer/Signature Section */
        .signature-section {
            display: flex;
            justify-content: space-evenly;
            font-size: 10pt;
            padding-top: 80px;
        }

        .signature-cell {
            border-left: none !important;
            border-bottom: none !important;
        }

        .signature-box {
            width: 45%;
            padding-top: 5px;
            border-top: 1px solid #000;
            text-align: center;
        }

        .signature-line {
            padding-top: 30px; /* Space for signature */
        }

      .footer-note {
            text-align: center;
            margin-top: 20px;
            font-size: 9pt;
            height: 20px;;
            font-weight: bold;
            background-color: blue;
            padding-top: 3px;
            padding-left: 5px;
            text-align: left;
            color: white; /* Reddish color for the warning */
        }

        /* Specific Content Styles */
        .date-srno-data {
            font-weight: bold;
            color: #333;
            font-family: 'Handwriting Font', 'Arial', sans-serif;
        }

        /* Hand-written signature placeholder */
        .receiver-signature-text {
            position: absolute;
            bottom: 25px;
            right: 175px; /* Adjust based on layout */
            font-size: 18pt;
            font-family: cursive; /* Placeholder font for signature look */
            transform: rotate(-10deg);
            color: #2c3e50;
        }

        /* Hand-written text for the total section */
        .total-amount-handwritten {
            font-size: 12pt;
            color: #2c3e50;
            font-family: 'Handwriting Font', 'Arial', sans-serif;
        }

        .label-color {
            background-color: blue;
            color: white;
        }

        /* Hide print template by default */
        .print-hidden {
            display: none !important;
        }

        /* Print styles for vue-html-to-paper */
        @media print {
            .receipt-container {
                page-break-inside: avoid;
                margin: 0 !important;
                box-shadow: none !important;
                border: 1px solid #000 !important;
                padding: 15px !important;
                width: 100% !important;
                max-width: none !important;
            }
            
            .header-logo img {
                max-height: 60px !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            
            .label-color {
                background-color: blue !important;
                color: white !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            
            .footer-note {
                background-color: blue !important;
                color: white !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
        }
</style>